import React, { useContext, useRef } from "react";

import { StatusBarDataItem } from "./helpers";
import styles from "./StatusBarChart.scss";

interface Dimensions {
  width: number | null;
  height: number | null;
  margin?: { top: number; right: number; bottom: number; left: number };
}

interface ChartContextState {
  data: StatusBarDataItem[];
  dimensions: Dimensions;
  linkLabel: string;
  linkUrl: string;
  newBarHeight: number;
  newTop: number;
  statusTitle?: string;
  statusDescription?: string;
  tooltips?: Record<string, { status?: string; text?: string }>;
  tooltipContent: React.FC<any>;
  svgRef: React.RefObject<SVGSVGElement>;
  resize?: boolean;
}

interface ChartContainerProps {
  children: React.ReactNode;
  state: Omit<ChartContextState, "svgRef">;
}

const StateContext = React.createContext<ChartContextState | null>(null);

export function ChartContainer({ children, state }: ChartContainerProps) {
  const svgRef = useRef<SVGSVGElement>(null);
  const ctxValue = { ...state, svgRef };
  return (
    <StateContext.Provider value={ctxValue}>
      <svg
        height="120px"
        width="100%"
        ref={svgRef}
        className={styles["chart"]}
        data-testid="chart-container"
      >
        {children}
      </svg>
    </StateContext.Provider>
  );
}

export function useChartContext(): ChartContextState {
  const context = useContext(StateContext);
  if (context === undefined || context === null) {
    throw new Error(
      "useChartContext must be used within a StatusBarChart's StateProvider"
    );
  }
  return context;
}
